import React, { useRef, useState } from "react";
import {
  CustomCard,
  CustomIconButton,
  CustomMenu,
  DeleteConfirmationDialog,
} from "../../../../../../../../Components";
import { Avatar, Box, Divider, Typography } from "@material-ui/core";
import {
  useSelectedTheme,
  useTranslate,
  useQuery,
} from "../../../../../../../../Hooks";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { PropertyVideoPreviewDialog } from "../PropertyVideoPreviewDialog";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { EditPropertyVideoDialog } from "../EditPropertyVideoDialog";
import {  DeletePropertyVideosCategory } from "../../../../../../../../Services";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";

// styles
import useStyles from "./styles";

// icons
import {
  Edit3Icon,
  Image01Icon,
  MoreVertIcon,
  PauseIcon,
  PlayButtonIcon,
  TrashOne,
} from "../../../../../../../../assets/icons";

function PropertyVideoCard({ data, setRefetchDataPropertyVideo }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { setAlertBoxContent } = useVerticalNav();
  const videoRefs = useRef({});
  const splideRef = useRef(null);
  const query = useQuery();
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const [isPreviewVideoDialogOpen, setIsPreviewVideoDialogOpen] =
    useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  const [isEditVideoDialogOpen, setIsEditVideoDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const deleteHandler = async () => {
    const res = await DeletePropertyVideosCategory(
      data.categoryId,
      Number(query.get("id"))
    );
    if (!(res && res.status && res.status !== 200)) {
      setAlertBoxContent({
        display: true,
        variant: "success",
        title: translate("categry-deleted-successfully"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
      setRefetchDataPropertyVideo(true);
    } else {
      const errorMessage = (res && res.data && res.data.Message).split(": ")[1];
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate(`${errorMessage}`),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };
  return (
    <>
      <CustomCard
        borderRadius="md"
        borderColor="secondary"
        classes={styles.containerVedioCard}
        onClick={() => {
          const currentIndex = splideRef.current?.splide?.index ?? 0;
          const currentVideo = data?.videos?.filter((vid) => vid.fileId)?.[
            currentIndex
          ];
          if (currentVideo) {
            setActiveVideo(currentVideo);
          }
          setIsPreviewVideoDialogOpen(true);
        }}
      >
        <Box
          className={styles.containerHeaderCard}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Box className={styles.splideWrapper}>
            <Splide
              className={styles.paginationDot}
              aria-label="Videos"
              options={{
                classes: { arrows: "splide__arrows details-tab-arrows" },
                start: 0,
                pagination: true,
              }}
              ref={splideRef}
            >
              {data?.videos
                ?.filter((vid) => vid.fileId)
                .map((videoItem) => (
                  <SplideSlide
                    key={videoItem.fileId}
                    className={styles.splideSlide}
                  >
                    <Box
                      className={styles.wrapperVideo}
                      onClick={() => {
                        setActiveVideo(videoItem);
                        setIsPreviewVideoDialogOpen(true);
                      }}
                    >
                      <video
                        ref={(el) => {
                          if (el) videoRefs.current[videoItem.fileId] = el;
                        }}
                        src={getDownloadableLink(videoItem.fileId)}
                        width="100%"
                        height="100%"
                        muted
                        className={styles.videoHover}
                        style={{ objectFit: "cover" }}
                      />

                      <Box
                        className={styles.conatinerPlayPauseIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          const video = videoRefs.current[videoItem.fileId];
                          if (!video) return;

                          if (video.paused) {
                            Object.entries(videoRefs.current).forEach(
                              ([id, vid]) => {
                                if (id !== videoItem.fileId && !vid.paused)
                                  vid.pause();
                              }
                            );
                            video.play();
                            setPlayingVideoId(videoItem.fileId);
                          } else {
                            video.pause();
                            setPlayingVideoId(null);
                          }
                        }}
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          cursor: "pointer",
                        }}
                      >
                        {playingVideoId === videoItem.fileId ? (
                          <PauseIcon />
                        ) : (
                          <PlayButtonIcon />
                        )}
                      </Box>
                    </Box>
                  </SplideSlide>
                ))}
            </Splide>
          </Box>
        </Box>

        <Box className={styles.containerBodyCard}>
          <Box className={styles.sectionMnueCategoryName}>
            <Typography className={styles.containerCategoryName}>
              {data?.categoryName}
            </Typography>
            <CustomMenu
              menuItems={[
                {
                  icon: (
                    <Edit3Icon
                      width="16"
                      height="16"
                      fill={palette.button.secondaryGray_fg}
                    />
                  ),
                  text: "Edit",
                  handler: () => {
                    const currentIndex = splideRef.current?.splide?.index ?? 0;
                    const currentVideo = data?.videos?.filter(
                      (vid) => vid.fileId
                    )?.[currentIndex];
                    if (currentVideo) {
                      setActiveVideo(currentVideo);
                      setIsEditVideoDialogOpen(true);
                    }
                  },
                },
                {
                  icon: (
                    <TrashOne
                      width="16"
                      height="16"
                      fill={palette.button.secondaryGray_fg}
                    />
                  ),
                  text: "Delete",
                  handler: () => {
                    setIsDeleteDialogOpen(true);
                  },
                },
              ]}
              activeIconClass={styles.menuActiveIconClass}
              defaultIconClass={styles.menuDefaultIconClass}
            >
              <CustomIconButton
                variant="text"
                size="xs"
                boxShadow="none"
                color="secondary"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <MoreVertIcon width="20" height="20" />
              </CustomIconButton>
            </CustomMenu>
          </Box>
          <Box className={styles.sectionCreatedBy}>
            <Box className={styles.containerItemAvatar}>
              <Avatar
                className={styles.AvatarStyle}
                src={"/images/contacts/MaleAvatar.svg"}
              ></Avatar>
            </Box>
            <Box className={styles.containerCreatedBy}>
              <Typography className={styles.createdByValue}>
                {data?.createdBy}
              </Typography>
              <Typography className={styles.createdByTitle}>
                {translate("Created-by")}
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Box className={styles.containerInfoProprety}>
            <Box className={styles.containerCountImages}>
              <Image01Icon
                width="20"
                height="20"
                fill={palette.utility.utility_gray_400}
              />
              <Typography className={styles.totalCountValue}>
                {data?.videos?.filter((vid) => !vid.videoLink)?.length ?? 0}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CustomCard>
      {isPreviewVideoDialogOpen && (
        <PropertyVideoPreviewDialog
          onOpen={isPreviewVideoDialogOpen}
          onClose={() => {
            setIsPreviewVideoDialogOpen(false);
          }}
          data={{
            ...data,
            videos: data?.videos?.filter((vid) => vid.fileId),
          }}
          activeVideo={activeVideo}
        />
      )}
      {isEditVideoDialogOpen && (
        <EditPropertyVideoDialog
          open={isEditVideoDialogOpen}
          onClose={() => {
            setIsEditVideoDialogOpen(false);
          }}
          data={{
            ...data,
            videos: data?.videos?.filter((vid) => vid.fileId),
          }}
          activeVideo={activeVideo}
          setRefetchDataPropertyVideo={setRefetchDataPropertyVideo}
        />
      )}

      {isDeleteDialogOpen && (
        <DeleteConfirmationDialog
          onClose={() => {
            setIsDeleteDialogOpen(false);
          }}
          title={translate("Your-Category-will-be-deleted")}
          subTitle={translate(
            "Are-you-sure-you-want-to-delete-this-Category-This-action-cannot-be-undone"
          )}
          onConfirm={() => {
            deleteHandler();
            setIsDeleteDialogOpen(false);
          }}
          confirmText={translate("Delete")}
        />
      )}
    </>
  );
}

export default PropertyVideoCard;
